import { registerPlugin } from '@capacitor/core';
const CFPaymentGateway = registerPlugin('CFPaymentGateway', {
    web: () => import('./web').then((m) => new m.CFPaymentGatewayWeb()),
});
export * from './definitions';
export * from './web';
export { CFPaymentGateway };
//# sourceMappingURL=index.js.map